// PREPARED ONLY - NOT WIRED INTO RUNTIME

export const YEAR_CONFIG = {
  // First year currently included in the historical dataset; used to build year ranges in future filters.
  baseYear: 2022,

  // Most recent year with available data right now; used to cap selectable years and validations later.
  lastDataYear: 2026,

  // Year shown when "All Years" mode needs a single sort anchor; kept to preserve current legacy behavior.
  defaultAllYearsSortYear: 2025,

  // Core yearly values tracked across conference data; used later by charts, summaries, and year comparisons.
  yearlyMetrics: ['Rooms', 'RN', 'Revenue'],

  // Reference year for year-over-year comparisons; used later as the default comparison baseline.
  comparisonAnchorYear: 2025
};
